// extracted by mini-css-extract-plugin
module.exports = {"tileWrap":"Tile_tileWrap__kN-lV","svgTile":"Tile_svgTile__3qqhR"};